import Vue from 'vue'
import {debounce} from 'lodash';

let EDITING_ELEMENT = null;

function getElementByXpath(path) {
    return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}

function getPathTo(element) {
    if (element.id)
        return 'id("'+element.id+'")';
    if (element===document.body)
        return element.tagName;

    let suffix = '';
    if (element.nodeType == 3) {
        suffix = '/text()';
    }

    var ix= 0;
    var siblings= element.parentNode.childNodes;
    for (var i= 0; i<siblings.length; i++) {
        var sibling= siblings[i];
        if (sibling===element)
            return getPathTo(element.parentNode)+  (element.tagName ? ('/'+element.tagName+'['+(ix+1)+']') : '')      +suffix;
        if (sibling.nodeType===1 && sibling.tagName===element.tagName)
            ix++;
    }
}

// FIXME: Only add this in edit mode?
const ZoeziEditable = {
    inserted: function (el, binding) {
        Vue.nextTick(() => {
            let findVueParent = function(x) {
                if (!x) {
                    return null;
                }
                if (x.__vue__ && x.__vue__.$options.name == 'ComponentWrapper') {
                    return x.__vue__;
                }

                return findVueParent(x.parentElement);
            };

            if (!window.$vue.edit) {
                return;
            }
            let options = {multiline: true, html: true, number: false};
            if (typeof binding.value == 'object') {
                Object.assign(options, binding.value);
            } else {
                options.prop = binding.value;
            }

            let save;
            let vueParent;
            let props;
            if (!options.setProp) {
                vueParent = findVueParent(el);
                if (!vueParent) {
                    return;
                }

                props = vueParent.config && vueParent.config.props;
                if (!props) {
                    return;
                }
            }

            if (!save) {
                if (vueParent) {
                    save = vueParent.save;
                } else {
                    save = window.$vue.saveHomePage;
                }
            }

            let fireClick = false;
            if (EDITING_ELEMENT && EDITING_ELEMENT.path == getPathTo(el)) {
                fireClick = true;
            }

            let onclick = function() {
                let originalValue = options.html ? el.innerHTML : el.innerText
                el.contentEditable = true;
                el.focus();

                let setAndSave = function() {
                    let value = options.html ? el.innerHTML : el.innerText
                    let validValue = true;
                    if (options.number) {
                        value = Number(value);
                        validValue = !isNaN(value);
                    }
                    let valueChanged = value != originalValue;
          
                    if (validValue) {
                        if (valueChanged) {
                            if (options.setProp) {
                                options.setProp(value)
                            } else {
                                setDescendantValue(props, options.prop, value);
                            }
                            save();
                            originalValue = value;

                            let sel = window.getSelection();

                            let caretStart = sel.anchorOffset;
                            let caretStartElement = getPathTo(sel.anchorNode);
                            let caretEnd = sel.focusOffset;
                            let caretEndElement = getPathTo(sel.focusNode);

                            EDITING_ELEMENT = {path: getPathTo(el), caretStart, caretEnd, caretStartElement, caretEndElement};
                        }
                    }
                };

                let debouncedSave = debounce(() => setAndSave(), 1000);

                let setDescendantValue = function(obj, desc, value) {
                    let arr = Array.isArray(desc) ? desc.concat() : desc.split('.');
                    while(arr.length > 1 && (obj = obj[arr.shift()])) {
                        // Empty
                    }

                    obj[arr[0]] = value;
                }

                let onblur;

                let onkeypress = function(event) {
                    if (!options.multiline && event.keyCode == 13) {
                        onblur();
                        event.preventDefault();
                        el.contentEditable = false;
                        EDITING_ELEMENT = null;
                    }
                };

                let oninput = function() {
                    debouncedSave();
                };

                onblur = function() {
                    let value = options.html ? el.innerHTML : el.innerText
                    let validValue = true;
                    if (options.number) {
                        value = Number(value);
                        validValue = !isNaN(value);
                    }
          
                    if (validValue) {
                        debouncedSave.flush();
                    } else {
                        if (options.html) {
                            el.innerHTML = originalValue;
                        } else {
                            el.innerText = originalValue;
                        }
                    }
          
                    el.removeEventListener('blur', onblur);
                    el.removeEventListener('keypress', onkeypress);
                    el.removeEventListener('input', oninput);
                };
                el.addEventListener('blur', onblur);
                el.addEventListener('keypress', onkeypress);
                el.addEventListener('input', oninput);
            };
  
            el.addEventListener('click', onclick);

            if (fireClick) {
                onclick();
                let cStart = getElementByXpath(EDITING_ELEMENT.caretStartElement);
                let cEnd = getElementByXpath(EDITING_ELEMENT.caretEndElement);
                if (cStart && cEnd) {
                    Vue.nextTick(() => {
                        let sel = window.getSelection()        
                        sel.removeAllRanges()
                        sel.setBaseAndExtent(cStart, EDITING_ELEMENT.caretStart, cEnd, EDITING_ELEMENT.caretEnd);
                        EDITING_ELEMENT = null;
                    });
                }
            }
        })
    }
};

export default {
    install(Vue) {
        Vue.directive('zoezi-editable', ZoeziEditable)
    }
}
